import Vue from 'deps/vue';
import * as paths from './shared/modules/paths';
// import vueCompositionApi from 'deps/vueCompositionApi'; //懒加载
import service from './service';

Vue.config.productionTip = false;
// Vue.use(vueCompositionApi);
// 插件
Vue.use(Vue => {
  // 添加实例属性
  Vue.prototype.$service = service;
  Vue.prototype.$paths = paths;
  Vue.prototype.$ItemStatus = {
    GUO_QI: -1,
    JIE_SUO_WEI_LING_QU: 1,
    WEI_WAN_CHENG: 2,
    JIE_SUO_LING_QU: 3,
    JIE_SUO_BU_KE_LING: 4,
  };
});

export default Vue;
